import React from "react";
import { Link } from "react-router-dom";

export default function LinkCommonComponent({
  extraClassName,
  linkPath,
  linkText,
  stateVal,
}) {
  return (
    <Link
      to={linkPath}
      state={stateVal}
      className={`login-btn-link ${extraClassName}`}
    >
      <p className="login-btn mb-0">{linkText}</p>
    </Link>
  );
}

LinkCommonComponent.defaultProps = {
  extraClassName: "",
  linkPath: "/",
  stateVal: null,
};
